import styled, { css } from "styled-components"

const Bold = styled.span(({ theme }) => css`
  font-weight: ${theme.fonts.headingWeight};
`);

export default Bold;